import Image from 'next/image';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import logoWheelleft from '@/public/images/logo_wheel_left.svg';
import logoWheelright from '@/public/images/logo_wheel_right.svg';
import settings from '@/settings/configs';
import { getShortenCountryName } from '@/lib/use-origin-country';
import { WebsiteSchema } from '@/components/homepage/WebsiteSchema';
import { loadGoogleSigninScript } from '@/lib/google-signin';
import CognitoRegisterForm from '@/components/commons/Customer/CognitoRegisterForm';
import i18n from '@/settings/i18n';

const t = i18n.init('auth');

export default function Register() {
  const router = useRouter();

  useEffect(() => {
    loadGoogleSigninScript();
  }, []);

  return (
    <>
      <WebsiteSchema
        title={t`Create Account - Reebelo ${{
          country: getShortenCountryName(),
        }}`}
        description={t`Reebelo ${{
          country: settings.country,
        }} is APAC's leading marketplace for sustainable tech with offices in ${{
          offices: settings.country_office_locations,
        }}. The positive customer experience at Reebelo ${{
          country: settings.country,
        }} is of utmost importance to us. Please check here for Reebelo ${{
          country: settings.country,
        }} Create Account.`}
      />
      <div className="relative bg-teal-500 py-5 md:py-14">
        <div className="reebelo-container my-0 md:my-2">
          <div
            className="mx-auto w-full max-w-[520px] rounded-[5px] bg-white px-6 py-5 shadow-xl md:px-20 md:py-10"
            id="e2e-registration-form"
          >
            <CognitoRegisterForm onSuccess={() => router.push('/')} />
          </div>
        </div>
        <div className="absolute left-0 top-0 hidden lg:block">
          <Image
            height={104}
            width={208}
            alt="logoWheelleft"
            src={logoWheelleft}
          />
        </div>
        <div className="absolute bottom-0 right-0 hidden leading-[0] lg:block">
          <Image
            height={392}
            width={241}
            alt="logoWheelright"
            src={logoWheelright}
          />
        </div>
      </div>
    </>
  );
}
